<div layout-fill layout="column" layout-align="center none">
    <div layout="row" layout-align="center none">
        <mat-card class="loggedOutCard" fxFlex.gt-xs="60%" fxFlex.gt-md="35%" fxFlex.xl="25%">
            <mat-card-header class="justifyContentCenter">
                <mat-card-title class="forgotPasswordTitle">Register</mat-card-title>
            </mat-card-header>
            <form id="registerForm" [formGroup]="registerFormGroup" (ngSubmit)="registerFormGroup.valid && captchaRef.execute()" novalidate autocomplete="off">
                <mat-card-content>
                    <div>
                        <mat-form-field class="full-width" appearance="outline" *ngIf="isProgram">
                            <mat-label>Program Code</mat-label>
                            <input matInput placeholder="Program Code" formControlName="programCode" [required]="isProgram" (blur)="checkProgramCode(); checkForDuplicateAccount()" #programCode="matInput">
                            <mat-error *ngIf="registerFormGroup.controls.programCode.errors?.notFound">Program Code is not valid</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input matInput placeholder="First Name" formControlName="firstName" required #firstname="matInput" (blur)="trimValue('firstName'); checkForDuplicateAccount()">
                            <mat-error *ngIf="registerFormGroup.controls.firstName.errors?.pattern">Only English characters are allowed</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline" *ngIf="isProgram && !requiresAdmissionsApplication">
                            <mat-label>Middle Name</mat-label>
                            <input matInput placeholder="Middle Name" formControlName="middleName" (blur)="trimValue('middleName'); ">
                            <mat-error *ngIf="registerFormGroup.controls.middleName.errors?.pattern">Only English characters are allowed</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input matInput placeholder="Last Name" formControlName="lastName" required (blur)="trimValue('lastName'); checkForDuplicateAccount()">
                            <mat-error *ngIf="registerFormGroup.controls.lastName.errors?.pattern">Only English characters are allowed</mat-error>
                        </mat-form-field>
                    </div>
                    <mat-form-field class="full-width" appearance="outline" *ngIf="isProgram && !requiresAdmissionsApplication">
                        <mat-select placeholder="Gender" formControlName="genderTypeId" [required]="isProgram && !requiresAdmissionsApplication" (blur)="checkForDuplicateAccount()">
                            <mat-option *ngFor="let gender of genders" [value]="gender.id">
                                {{gender.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width" appearance="outline" *ngIf="isProgram && !requiresAdmissionsApplication">
                        <input matInput [matDatepicker]="dateOfBirth" placeholder="Date of Birth (mm/dd/yyyy)" formControlName="dateOfBirth" [required]="isProgram && !requiresAdmissionsApplication" (click)="dateOfBirth.open()" (blur)="checkForDuplicateAccount()">
                        <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                        <mat-datepicker #dateOfBirth [touchUi]="isMobile"></mat-datepicker>
                    </mat-form-field>
                    <div style="display: none">
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" name="email" id="email">
                        </mat-form-field>
                    </div>
                    <div style="display: none">
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput placeholder="Password" name="password" id="password">
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline" hintLabel="The email address used should be valid throughout your stay at JCU">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" formControlName="eml" required id="eml">
                            <mat-error *ngIf="registerFormGroup.controls.eml.errors?.email">Not a valid email</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Confirm Email</mat-label>
                            <input matInput placeholder="Confirm Email" formControlName="confirmEml" required id="confirmEml">
                            <mat-error *ngIf="registerFormGroup.controls.confirmEml.errors?.email">Not a valid email</mat-error>
                            <mat-error *ngIf="registerFormGroup.controls.confirmEml.errors?.match">Emails must match</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput placeholder="Password" type="password" formControlName="pass" required [type]="hideConfirm ? 'password' : 'text'" autocomplete="new-password" id="pass">
                            <mat-icon matSuffix (click)="hideConfirm = !hideConfirm" class="showPasswordIcon cursorPointer">{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="registerFormGroup.controls.pass.errors?.pattern">At least 8 characters containing a number and a special character (@$!%*#?&)</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput placeholder="Password" type="password" formControlName="confirmPass" required [type]="hide ? 'password' : 'text'" id="confirmPass" autocomplete="new-password">
                            <mat-icon matSuffix (click)="hide = !hide" class="showPasswordIcon cursorPointer">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="registerFormGroup.controls.confirmPass.errors?.match">Passwords must match</mat-error>
                        </mat-form-field>
                    </div>
                    <recaptcha-demo-wrapper>
                        <re-captcha #captchaRef="reCaptcha" (resolved)="$event && onSubmit($event, submitBtn)" siteKey="6LddipIUAAAAAEv80F-3lm4z2j3ZvJ6My--r-BRs" size="invisible"></re-captcha>
                    </recaptcha-demo-wrapper>
                </mat-card-content>
                <mat-card-actions>
                    <button id="registerBtn" mat-raised-button color="primary" class="loginBtn" type="submit" #submitBtn>Create Account</button>
                    <a mat-button routerLink="/login" class="padding0 fontWeight400">Already Have an Account? Login Here</a>
                </mat-card-actions>
            </form>
        </mat-card>
    </div>
</div>

